import styled from "styled-components";

const Overlay = styled.div`
   inset: 0;
   z-index: 90;
   display: flex;
   position: fixed;
   background: rgba(0, 0, 0, 0.4);
   justify-content: flex-end;
`;

const Panel = styled.div`
   width: 380px;
   max-width: 100%;
   overflow-y: auto;
   height: 100vh;
   background: #FFFFFF;
   border-left: 1px solid #EDEDEE;
   box-shadow: -4px 0 12px -2px rgba(16,24,40,0.05);
   display: flex;
   flex-direction: column;
   padding: 24px 24px 40px;
   animation: slideIn .35s cubic-bezier(.4,0,.2,1);

   @keyframes slideIn {
      from { transform: translateX(40px); opacity: 0 }
      to { transform: translateX(0); opacity: 1 }
   }
`;

const TitleRow = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 10px;
`;

const H1 = styled.h2`
   font-size: 23px;
   font-weight: 600;
   margin: 0;
   color: #101018;
`;

const CloseBtn = styled.button`
   background: none;
   border: none;
   cursor: pointer;
   font-size: 18px;
   line-height: 1;
   color: #3F3F45;
   padding: 4px;
`;

const Section = styled.div`
   margin-top: 28px;
   &:first-of-type { margin-top: 0; }
`;

const SectionTitle = styled.h3`
   font-size: 19px;
   font-weight: 600;
   margin: 0 0 12px;
   color: #101018;
`;

const Grid = styled.div`
   display: grid;
   grid-template-columns: minmax(120px, auto) 1fr;
   row-gap: 18px;
   font-size: 14px;
   letter-spacing: -0.025em;
`;

const Label = styled.div`
   font-size: 14px;
   color: #9C9C9F;
   letter-spacing: -0.025em;
`;

const Value = styled.div`
   font-size: 14px;
   color: #56565C;
   text-align: right;
   font-family: 'Geist Mono', 'Geist', monospace;
`;


export {
   Overlay,
   Panel,
   TitleRow,
   H1,
   CloseBtn,
   Section,
   SectionTitle,
   Grid,
   Label,
   Value
}